import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import panelApi from "@/lib/panelApi";
import { useFetch } from "@/hooks/useFetch";
import { useBase } from "@/context/BaseContext";

export const HOLIDAYS_KEY = ["panel-holidays"];

export const useHolidays = () => useQuery({
  queryKey: HOLIDAYS_KEY,
  queryFn: async () => (await panelApi.get("/panel/holidays")).data?.holidays || [],
});

// (date, personId, baseName) => feriado aplicável? Globais valem para todos; os de base valem para quem é da base.
export const useHolidayChecker = () => {
  const { data: holidays } = useHolidays();
  const { bases, selectedBaseId } = useBase();
  const collabs = useFetch("/admin/collaborators");
  const list = collabs.data?.collaborators;
  return useCallback((date, personId, baseName) => {
    const hs = (holidays || []).filter((h) => h.date === date);
    if (!hs.length) return false;
    if (hs.some((h) => !h.base_id || h.base_id === selectedBaseId)) return true;
    const pBases = (list || []).find((c) => c.id === personId)?.base_ids || [];
    return hs.some((h) => pBases.includes(h.base_id)
      || (baseName && (bases || []).find((b) => b.id === h.base_id)?.name === baseName));
  }, [holidays, list, bases, selectedBaseId]);
};
